module.exports = __webpack_public_path__ + "/fc36941276743be56601ff12b737bde7.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/screenshot_slack.gif
 ** module id = 1640
 ** module chunks = 0
 **/